import React, { useState, useRef, useContext } from "react";
import { debounce } from "lodash";
import CustomizerContext from "../../_helper/Customizer";
const CustomAutoSuggest = ({
  handleSelectChange,
  placeholder,
  options,
  id,
  registerName,
  register,
  inputType,
  inputProps,
  isClearable,
  setValue,
  dependentRegisterName,
  isInitialLoadData
}) => {
  const {mix_background_layout} = useContext(CustomizerContext)
  const properties = inputProps ? inputProps : { required: false };
  // const registerWatch=watch(registerName);

  const [registerValue, setRegisterValue] = useState("");
  const selectRef = useRef();

  const canClearInput = isClearable ? true : false;
  console.log(canClearInput, registerName, "canClearInput");
  const clearValue = () => {
    setRegisterValue(undefined);
    setValue(registerName, undefined);
    if(dependentRegisterName) setValue(dependentRegisterName,{})
    setData([])
  };
  // const registerName = "input_value";
  const [focusFlag, setFocusFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const onInputFocus = (event) => {
    selectRef.current.style.borderColor = "#2684ff";
    selectRef.current.style.boxShadow = "0 0 0 1px #2684ff";
    setFocusFlag(true);
    searchData(event);
  };
  const onInputBlur = (ele) => {
    selectRef.current.style.borderColor = mix_background_layout == "dark-only" ? "#374558" : "#cccccc";
    selectRef.current.style.boxShadow = "none";
    setTimeout(() => {
      setFocusFlag(false);
    }, 300);
  };

  const searchData = async (event) => {
    const value = event.target.value;
    setRegisterValue(value);
    if (!value && !isInitialLoadData) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      if(value.length>2){
        console.log(value)
        await options(value).then((result) => {
          setData(result);
          setLoading(false);
        });
      }

    } catch (err) {
      setData([]);
      
    }
  };

  const onInputChange = async (event) => {
    if (!focusFlag) return;
    searchData(event);
  };

  const debounceData = debounce(onInputChange, 500);

  const onOptionSelect = (element) => {
    setFocusFlag(false);
    setRegisterValue(element);
    handleSelectChange(element);
  };

  return (
    <div className={`autosuggest-container`} >
      <div className={`autosuggest-select`} ref={selectRef} 
      style={{
        backgroundColor: properties.disabled ? "hsl(0, 0%, 95%)" : mix_background_layout == "dark-only" ? "#1d1e26" : "white",
        borderColor: mix_background_layout == "dark-only" ? "#374558" : null
        }}>
        <div className={`autosuggest-select-box`}>
          <input
            style={
              { width: !loading && !canClearInput ? "100%" : "90%",color: mix_background_layout == "dark-only" ? "#98a6ad" : null }
            }
            id={id}
            onFocus={onInputFocus}
            className={`text-input`}
            type={inputType ? inputType : "text"}
            autoComplete="off"
            placeholder={placeholder ? placeholder : ""}
            {...register(registerName, {
              ...properties,
              onBlur: onInputBlur,
              onChange: debounceData,
            })}
          />
          {loading ? <div className="suggestion-loader" /> : ""}
          {registerValue && !loading && canClearInput ? (
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => clearValue()}
            ></button>
          ) : (
            ""
          )}
        </div>
        <div className={`caret-box`}>
          <i className="fa fa-angle-down"></i>
        </div>
      </div>
      {focusFlag ? (
        <div className={`autosuggest-options`}>
          <div className={`suggestions-options-box`}>
            {data && data.length > 0 && !loading ? (
              data.map((element, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      onOptionSelect(element);
                    }}
                    className={`select-options-box`}
                  >
                    {element.label}
                  </div>
                );
              })
            ) : (
              <div className={`no-options-box`}>
                {loading ? "Loading..." : "No options"}
              </div>
            )}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomAutoSuggest;
